import React  from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  getToken, 
  // getPermissions,
} from "./Helpers/Utils/Common";
import { Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { toastStyle } from "./Helpers/Utils/Common";
import "./App.css";

/** PAGES **/
import OrderingPage from "./Pages/OrderingPage/OrderingPage";
import OrderStatus from "./Pages/OrderingPage/OrderStatus";
import LoginAdmin from "./Pages/LoginAdmin/LoginAdmin";
import UserManager from "./Pages/UserManager/UserManager";
import MenuManager from "./Pages/MenuManager/MenuManager";
import Inventory from "./Pages/MenuManager/Inventory";
import CategoryManager from "./Pages/CategoryManager/CategoryManager";
import Payment from "./Pages/Payment/Payment";
import CashCount from "./Pages/Cashier/CashCount/CashCount";
import Sales from "./Pages/Report/Sales";
import CashCounts from "./Pages/Report/CashCounts";
import ViewCashCount from "./Pages/Cashier/CashCount/ViewCashCount";
import Discount from "./Pages/Discount/Discount";
import ClosedInvoices from "./Pages/ClosedInvoice/ClosedInvoices";
import ItemHistory from "./Pages/Report/ItemHistory";
import XReading from "./Pages/Report/XReading";
import ZReading from "./Pages/Report/ZReading";
// import OrdersUpdate from "./Pages/OrdersUpdate/OrdersUpdate";
import SeniorDiscounts from "./Pages/Report/SeniorDiscounts";
import PWDDiscounts from "./Pages/Report/PWDDiscounts";
import OtherDiscounts from "./Pages/Report/OtherDiscount";
import AuditTrails from "./Pages/Report/AuditTrails";
import CancelledSI from "./Pages/Report/CancelledSI";
import Ejournal from "./Pages/Report/Ejournal";
import InventoryManager from "./Pages/MenuManager/InventoryManager";
import CategoryReport from "./Pages/Report/CategoryReport";
import ModifierReport from "./Pages/Report/ModifierReport";
import PaymentReport from "./Pages/Report/Payments";
import DailySales from "./Pages/Report/DailySales";

function App() {
  //APP NAME
  document.title = "SMASH";
  document.body.style = "background: #ffffff;";
  const token = getToken();
  // const userPermission = getPermissions();

  return (
    <div className="page">
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{ style: { toastStyle } }}
      />
      <Router>
        <Routes>
          <Route path="/" element={<LoginAdmin />} />
          <Route
            path="/orderingpage"
            element={
              token ? <OrderingPage /> : <Navigate to="/" />
            }
          />
          <Route
            path="/userManager"
            element={token ? <UserManager /> : <Navigate to="/" />}
          />
          <Route
            path="/menuManager"
            element={token ? <MenuManager /> : <Navigate to="/" />}
          />
          <Route
            path="/inventory/:id"
            element={token ? <Inventory /> : <Navigate to="/" />}
          />
          <Route
            path="/receiving-report"
            element={token ? <InventoryManager /> : <Navigate to="/" />}
          />
          <Route
            path="/categoryManager"
            element={token ? <CategoryManager /> : <Navigate to="/" />}
          />
          <Route
            path="/discountsManager"
            element={token ? <Discount /> : <Navigate to="/" />}
          />
           <Route
            path="/add-payment/:orderID"
            element={token ? <Payment /> : <Navigate to="/" />}
          />

          <Route
            path="/add-cash-count"
            element={token ? <CashCount /> : <Navigate to="/" />}
          />

          <Route
            path="/sales-report"
            element={token ? <Sales /> : <Navigate to="/" />}
          />
          <Route
            path="/item-history-report"
            element={token ? <ItemHistory /> : <Navigate to="/" />}
          />
          <Route
            path="/cash-counts-report"
            element={token ? <CashCounts /> : <Navigate to="/" />}
          />

          <Route
            path="/category-report"
            element={token ? <CategoryReport /> : <Navigate to="/" />}
          />

          <Route
            path="/modifier-report"
            element={token ? <ModifierReport /> : <Navigate to="/" />}
          />

          <Route
            path="/payment-report"
            element={token ? <PaymentReport /> : <Navigate to="/" />}
          />  

          <Route
            path="/cash-counts-report/view/:id"
            element={token ? <ViewCashCount /> : <Navigate to="/" />}
          />

          <Route
            path="/senior-discounts-sales-report"
            element={token ? <SeniorDiscounts /> : <Navigate to="/" />}
          />

          <Route
            path="/pwd-discounts-sales-report"
            element={token ? <PWDDiscounts /> : <Navigate to="/" />}
          />

          <Route
            path="/other-discounts-sales-report"
            element={token ? <OtherDiscounts /> : <Navigate to="/" />}
          />

          <Route
            path="/audit-trails-report"
            element={token ? <AuditTrails /> : <Navigate to="/" />}
          />

          <Route
            path="/cancelled-report"
            element={token ? <CancelledSI /> : <Navigate to="/" />}
          />

          <Route
            path="/ejournal-report"
            element={token ? <Ejournal /> : <Navigate to="/" />}
          />

          <Route
            path="/x-reading-report"
            element={token ? <XReading /> : <Navigate to="/" />}
          />

          <Route
            path="/closedinvoices"
            element={token ? <ClosedInvoices /> : <Navigate to="/" />}
          />

          <Route
            path="/z-reading-report"
            element={token ? <ZReading /> : <Navigate to="/" />}
          />
          <Route
            path="/daily-sales-report"
            element={token ? <DailySales /> : <Navigate to="/" />}
          />
          <Route
            path="/order-status"
            element={<OrderStatus />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
